import moment from "moment";

function Badge({ isComplete, logo = null }) {
    // let date = moment(challenge?.startdate);
    return (
        <div id="milestone-badge" className={isComplete ? "active" : ""}>
            <img src={!logo ? (`/assets/images/badge/default${isComplete ? "-active" : ""}.png`) : logo} className="badge-img" style={logo ? { width: "90%" } : null} />
        </div>
    );
}

export default Badge;